import React, { Component, Fragment } from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { Grid, Header, Button, Tab, Form } from 'semantic-ui-react';
import { withRouter } from 'react-router';

import { YesNoDialog } from 'Components';
import { InputField, SelectField } from 'Common/SemanticWrapper';
import { FileFieldEnum } from 'Common/FieldEnum';
import { renderField } from 'Common/FormHelper';
import { ImportStudentEnum } from 'Common/Constants/Enumeration/ImportStudentEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { IMPORT_SETTINGS } from 'Common/FormEnum';
import { MappingTypeEnum } from 'Common/Constants/Enumeration/MappingTypeEnum';
import { FileEncodingOptions } from 'Common/Constants/Enumeration/FileEncodingEnum';
import { ImportSettingsTable } from './components/ImportSettingsTable';

import MappingModal from './MappingModal';
import * as actions from './state/actions';
import { mealsDataMapped, mealOptions, mealStatuses } from './fixtures';

class ImportSettingsContainer extends Component {
  state = {
    showModal: false,
    headerValue: '',
    type: MappingTypeEnum.Meal,
    mealStatusValue: 4,
    changeFile: false,
    showDeleteDialog: false,
  };

  exportTypeButtons = [
    { label: 'Manual', value: ImportStudentEnum.Default },
    { label: 'Auto', value: ImportStudentEnum.Auto },
  ];

  headerRowButtons = [
    { title: 'Yes', value: true },
    { title: 'No', value: false },
  ];

  withdrawNotInFileRowButtons = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  mealStatusButtons = [
    { title: 'Set Default Meal Status', value: false },
    { title: 'Map Meal Status To Field', value: true },
  ];

  saveData = (data) => {
    const { dispatch } = this.props;
    const { type } = this.state;

    switch (type) {
      case MappingTypeEnum.Language:
        dispatch(actions.addLanguageMappingDataAction(data));
        break;
      case MappingTypeEnum.MealStatus:
        dispatch(actions.addingMealMappingDataAction(data));
        break;
      case MappingTypeEnum.Site:
        dispatch(actions.setSiteMappingDataAction(data));
        break;
      case MappingTypeEnum.Grade:
        dispatch(actions.setGradeMappingDataAction(data));
        break;
      default:
        break;
    }
  };

  // Why does this in the parent? Can it be in te MappingModal?
  updateData = (data) => {
    this.props.change(`${FileFieldEnum.SourceValue}`, data);
  };

  get mappingModalProps() {
    const {
      finalLanguageMappedValues,
      finalMealMappedValues,
      siteOptions,
      sitesMappedDescriptions,
      sitesMapped,
      gradeOptions,
      gradesMappedDescriptions,
      gradesMapped,
      languageDataMapped,
      languageOptions,
    } = this.props;
    const { type } = this.state;

    switch (type) {
      case MappingTypeEnum.Language:
        return {
          headerValue: 'Language Mapping',
          dataMapped: languageDataMapped,
          options: languageOptions,
          finalMappedValues: finalLanguageMappedValues,
          type,
        };
      case MappingTypeEnum.MealStatus:
        return {
          headerValue: 'Meal Status Mapping',
          dataMapped: mealsDataMapped,
          options: mealOptions,
          finalMappedValues: finalMealMappedValues,
          type,
        };
      case MappingTypeEnum.Site:
        return {
          headerValue: 'Site Mapping',
          dataMapped: sitesMappedDescriptions,
          options: siteOptions,
          finalMappedValues: sitesMapped,
          type,
        };
      case MappingTypeEnum.Grade:
        return {
          headerValue: 'Grade Mapping',
          dataMapped: gradesMappedDescriptions,
          options: gradeOptions,
          finalMappedValues: gradesMapped,
          type,
        };
      default:
        return { finalMappedValues: [] };
    }
  }

  toggleModal = (type) => {
    let newState = {
      showModal: !this.state.showModal,
      type,
    };

    this.setState(newState);
  };

  mealStatusPanes = () => {
    return [
      {
        menuItem: 'Set Default Meal Status',
        value: false,
        render: () => (
          <div className="tab--content">
            <label className="d-block">Default Meal Status:</label>
            <Field
              name={FileFieldEnum.MealStatusDropDown}
              component={SelectField}
              options={mealStatuses}
              style={{ width: 'initial' }}
            />
          </div>
        ),
      },
      {
        menuItem: 'Map Meal Status To Field',
        value: true,
        render: () => (
          <div className="tab--content">
            <label className="d-block">Map Meal Status:</label>
            <Button
              type="button"
              onClick={() => this.toggleModal(MappingTypeEnum.MealStatus)}
            >
              Set Custom Map Meal Status
            </Button>
          </div>
        ),
      },
    ];
  };

  confirmDelete = () => {
    this.setState(
      {
        showDeleteDialog: false,
      },
      () => this.deleteImportSettings()
    );
  };

  deleteImportSettings = async () => {
    const { dispatch } = this.props;
    dispatch(actions.deleteAutoImport(this.state.deleteId));
  };

  cogOptions = [
    {
      icon: 'pencil',
      text: 'View/Edit',
      handler: (row) => {
        this.props.history.push(`/importstudents/autoimportsetup/${row.Id}`);
      },
      disabledWhen: (row) => row.isEditDisabled,
    },
    {
      icon: 'trash',
      text: 'Delete',
      handler: (row) => {
        this.setState({
          showDeleteDialog: true,
          deleteId: row.Id,
        });
      },
      disabledWhen: (row) => row.isEditDisabled,
    },
  ];

  render() {
    const {
      dispatch,
      isFirstRowHeader,
      useMappedValue,
      importTypeId,
      handleSubmit,
      onFileEncodingChange,
      importSettingsData,
    } = this.props;
    const { showModal, showDeleteDialog } = this.state;

    return (
      <Fragment>
        <legend>
          <Header content="Import Settings" color="orange" />
        </legend>
        <Form onSubmit={handleSubmit}>
          <Grid>
            <Grid.Row />
            <Grid.Row columns={2}>
              <Grid.Column>
                <SecurityPreferences scope={PrefEnum.AutoImportSettings}>
                  {(disabled) => {
                    return (
                      <ReduxFormButtonGroup
                        label={'Import Type:'}
                        formName={IMPORT_SETTINGS}
                        fieldName={FileFieldEnum.Id}
                        options={this.exportTypeButtons}
                        disabled={disabled}
                      />
                    );
                  }}
                </SecurityPreferences>
              </Grid.Column>
              <Grid.Column
                style={{
                  textAlign: 'end',
                  alignSelf: 'flex-end',
                }}
              >
                {importTypeId === ImportStudentEnum.Auto && (
                  <Button
                    type="button"
                    onClick={() =>
                      this.props.history.push(
                        `/importstudents/autoimportsetup/0`
                      )
                    }
                  >
                    Create New
                  </Button>
                )}
              </Grid.Column>
            </Grid.Row>
            {importTypeId === ImportStudentEnum.Auto && (
              <Grid.Row>
                <Grid.Column>
                  <ImportSettingsTable
                    cogOptions={this.cogOptions}
                    data={importSettingsData ? importSettingsData : []}
                  ></ImportSettingsTable>
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
          {importTypeId === ImportStudentEnum.Default && (
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <label className="d-block">
                    Does the first row contain header information:
                  </label>
                  <Button.Group basic className="btn-group--active-group">
                    {this.headerRowButtons.map((button) => (
                      <Button
                        key={button.title}
                        basic
                        className="white"
                        active={isFirstRowHeader === button.value}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(
                            change(
                              IMPORT_SETTINGS,
                              FileFieldEnum.HeaderRowRadio,
                              button.value
                            )
                          );
                        }}
                      >
                        {button.title}
                      </Button>
                    ))}
                  </Button.Group>
                  <Field
                    name={FileFieldEnum.HeaderRowRadio}
                    component={renderField}
                    props={{ type: 'hidden' }}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Field
                    name={FileFieldEnum.FileEncoding}
                    component={SelectField}
                    options={FileEncodingOptions}
                    label="File Encoding"
                    onChange={onFileEncodingChange}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <ReduxFormButtonGroup
                    formName={IMPORT_SETTINGS}
                    label="Withdraw students not in file:"
                    fieldName={FileFieldEnum.WithdrawNotInFileRowRadio}
                    options={this.withdrawNotInFileRowButtons}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column largeScreen={4}>
                  <Field
                    name={FileFieldEnum.EnrolledValue}
                    type="text"
                    component={InputField}
                    label="Enrolled Value"
                    maxLength={10}
                  />
                </Grid.Column>
                <Grid.Column largeScreen={4}>
                  <Field
                    name={FileFieldEnum.WithdrawnValue}
                    type="text"
                    component={InputField}
                    label="Withdrawn Value"
                    maxLength={10}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <label className="d-block">
                    Meal Status Mapping Options:
                  </label>
                  <Tab
                    panes={this.mealStatusPanes()}
                    activeIndex={Number(useMappedValue)}
                    onTabChange={(e, d) => {
                      if (useMappedValue !== !!d.activeIndex) {
                        dispatch(
                          change(
                            IMPORT_SETTINGS,
                            FileFieldEnum.UseMappedValue,
                            !!d.activeIndex
                          )
                        );
                      }
                    }}
                  />
                  <Field
                    name={FileFieldEnum.UseMappedValue}
                    component={renderField}
                    props={{ type: 'hidden' }}
                    value="false"
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={3}>
                <Grid.Column>
                  <label className="d-block">Language Mapping Options:</label>
                  <Button
                    type="button"
                    onClick={() => this.toggleModal(MappingTypeEnum.Language)}
                  >
                    Set Custom Language Mapping
                  </Button>
                </Grid.Column>
                <Grid.Column>
                  <label className="d-block">Site Mapping Options:</label>
                  <Button
                    type="button"
                    onClick={() => this.toggleModal(MappingTypeEnum.Site)}
                  >
                    Set Custom Site Mapping
                  </Button>
                </Grid.Column>
                <Grid.Column>
                  <label className="d-block">Grade Mapping Options:</label>
                  <Button
                    type="button"
                    onClick={() => this.toggleModal(MappingTypeEnum.Grade)}
                  >
                    Set Custom Grade Mapping
                  </Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row />
            </Grid>
          )}
          <Grid style={{ paddingBottom: '50px' }} />
          <MappingModal
            showEditModal={showModal}
            onClose={this.toggleModal}
            updateData={this.updateData}
            saveData={this.saveData}
            {...this.mappingModalProps}
          />
        </Form>
        <YesNoDialog
          title="Confirm Delete"
          question="Are you sure you want to delete import settings"
          isSavePrompt={false}
          showDialog={showDeleteDialog}
          yesCallback={this.confirmDelete}
          noCallback={() => this.setState({ showDeleteDialog: false })}
        />
      </Fragment>
    );
  }
}

const ImportSettings = reduxForm({
  destroyOnUnmount: false,
  form: IMPORT_SETTINGS,
})(withRouter(ImportSettingsContainer));

export { ImportSettings };



// WEBPACK FOOTER //
// ./src/pages/importstudents/ImportSettings.js